import { G } from '@mobily/ts-belt'
import { defineStore } from 'pinia'

import { authService } from '@/services/authService'

import { useGlobalStore } from './globalStore'
import type { User } from './types'

export type State = {
  user?: User
}

export const useAuthStore = defineStore('authStore', {
  actions: {
    async refreshUserData() {
      const globalStore = useGlobalStore()
      const userIdFormAccessToken = authService.userIdFormAccessToken()

      if (G.isNotNullable(userIdFormAccessToken)) {
        const response = await authService.fetchUser(userIdFormAccessToken)
        globalStore.setUser({ user: response.data })
      }
    },
    async verifyAuth() {
      try {
        await authService.verifyAccessToken()
      } catch {
        await authService.refreshAccessToken()
      }
      const globalStore = useGlobalStore()
      const userIdFromState = globalStore.user?.id
      const userIdFormAccessToken = authService.userIdFormAccessToken()

      if (G.isNotNullable(userIdFormAccessToken) && userIdFromState !== userIdFormAccessToken) {
        const response = await authService.fetchUser(userIdFormAccessToken)
        this.user = response.data
        globalStore.setUser({ user: response.data })
      }
    },
  },
  state: (): State => ({
    user: undefined,
  }),
})
